import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { FaWarehouse, FaShoppingCart, FaClipboardList, FaChartBar, FaTags, FaDownload } from 'react-icons/fa';

const NavigationBar = () => {
  const location = useLocation();
  
  return (
    <Navbar bg="dark" variant="dark" expand="lg" sticky="top" className="mb-4">
      <Container>
        <Navbar.Brand as={Link} to="/">
          <FaWarehouse className="me-2" />
          Lagerverwaltung
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbar-nav" />
        <Navbar.Collapse id="navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link as={Link} to="/" active={location.pathname === '/'}>
              <FaChartBar className="me-1" /> Dashboard
            </Nav.Link>
            <Nav.Link as={Link} to="/artikel" active={location.pathname === '/artikel'}>
              <FaWarehouse className="me-1" /> Artikel
            </Nav.Link>
            <Nav.Link as={Link} to="/etikettendruck" active={location.pathname.startsWith('/etikettendruck')}>
              <FaTags className="me-1" /> Etikettendruck
            </Nav.Link>
            <Nav.Link as={Link} to="/artikel/export" active={location.pathname === '/artikel/export'} style={{color: '#ffc107'}}>
              <FaDownload className="me-1" /> Artikeldaten-Export
            </Nav.Link>
            <Nav.Link as={Link} to="/warenkorb" active={location.pathname === '/warenkorb'}>
              <FaShoppingCart className="me-1" /> Warenkorb
            </Nav.Link>
            <Nav.Link as={Link} to="/bestellungen" active={location.pathname.startsWith('/bestellungen')}>
              <FaClipboardList className="me-1" /> Bestellungen
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavigationBar;
